module.exports = __webpack_public_path__ + "img/footer_logo@2x.8b9e3016.png";